<template>
    <div style="height: 100%; overflow: auto">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <!--   <span class="sa-flexbox-body-title">Storico</span> -->
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template v-slot:cell(index)="row">
                            <span> {{ (currentPage - 1) * perPage + row.index + 1 }}</span>
                        </template>
                        <template v-slot:cell(dataOra)="{ item }">
                            <span>{{ formatDateTime(item.createDate) }}</span>
                        </template>
                        <!--     <template v-slot:cell(actions)="{ item }">
                            <b-container class="bv-example-row">
                                <b-button size="sm" v-b-tooltip.hover title="Modifica Richiesta" variant="outline-success" @click="onEditPersonaRiferimento(item)">
                                    <font-awesome-icon icon="edit"></font-awesome-icon>
                                </b-button>
                                <b-button size="sm" v-b-tooltip.hover title="Cancella Richiesta" variant="outline-danger" @click="onDeletePersonaRiferimento(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template> -->
                    </b-table>
                </div>
            </div>
            <div class="sa-flexbox-footer" style="background-color: ciano">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <modal-error ref="cmpModalError"></modal-error>
        <print-component v-show="false" ref="cmpPrint"></print-component>
    </div>
</template>
<script>
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
    props: {
        jsonData: { type: Object },
    },
    components: { ModalError, PrintComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/rsapostilettoaccettazione",
            idAccettazione: "",
            id: "",
            rows: 0,
            listKey: 0,
            currentPage: 1,
            perPage: 50,
            items: [],
            accettazione: {},
            fields: [
                { label: "", key: "index" },

                {
                    label: "Nome Piano",
                    key: "nomePiano",
                },
                {
                    label: "Nome Stanza",
                    key: "nomeStanza",
                },

                {
                    label: "Nome Letto",
                    key: "nomeLetto",
                },
                {
                    label: "Data Ora",
                    key: "dataOra",
                },
                /*  {
                    label: "",
                    key: "actions",
                    class: "sa-table-column-action-double",
                }, */
            ],
        };
    },
    mounted() {},
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        init(data) {
            let me = this;
            me.accettazione = data;
            me.idAccettazione = data.id;
            me.loadData();
        },
        loadData() {
            let me = this;
            me.loadDataResources(me.pathResource, { idAccettazione: me.idAccettazione, page: me.currentPage, forPage: me.perPage }, me.resultResponse, me.resultError);
        },
        resultResponse(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.listKey++;
        },
        resultError(error) {
            console.log(error);
        },
    },
};
</script>
